import Lottie from 'lottie-react';
import { t } from 'i18next';
import loadingAnimation from '../../../src/lotties/loading_gray.json';

const RegisterLoadingPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <Lottie animationData={loadingAnimation} loop={true} style={{ height: '31px' }} />
      <h1 className="mt-[28px] py-[10px] text-[26px] font-bold text-text-main-lv1">
        {t('NewTradingPhotoCards.loadingMessage')}
      </h1>
    </div>
  );
};

export default RegisterLoadingPage;
